/**
 * Subscription status utilities for extracting data from access token
 */ import { getAccessTokenPayload } from './jwt-utils';
/**
 * Mapping of access token offer keys to subscription status product keys
 */ const OFFER_MAPPING = {
    CS_SUB: 'chegg_study',
    EB_SUB: 'chegg_writing_tool',
    MATH_SUB: 'chegg_math'
};
/**
 * Extract subscription status from access token
 * Returns subscription status for each product offering based on userTags.offers
 *
 * Returns:
 * - SubscriptionStatus object with "active"/"inactive" values when token is available
 * - null when access_token is not available
 */ export function getSubscriptionStatusFromToken() {
    try {
        const payload = getAccessTokenPayload();
        if (!payload?.userTags?.offers) {
            return null;
        }
        const offers = payload.userTags.offers;
        const result = {
            chegg_study: 'inactive',
            chegg_writing_tool: 'inactive',
            chegg_math: 'inactive'
        };
        // Check each product offering
        Object.entries(OFFER_MAPPING).forEach(([offerKey, productKey])=>{
            if (offers.includes(offerKey)) {
                result[productKey] = 'active';
            }
        // Note: we already set everything to 'inactive' by default, so no else needed
        });
        return result;
    } catch (error) {
        console.error('Error extracting subscription status from token:', error);
        return null;
    }
}
